var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { Alert, Spin, message, Modal, Button } from "antd";
import { useLocation } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useApplicationContext } from "../../context/application-context";
import apiClientServices from "../../api-client";
import { Block, BlockCard, BlockTitle, CommentsTextArea, SectionBody, SectionCard, SectionDivider, SectionHeader, SubmitButton, SubmitButtonWrapper, Wrapper, BlockCardCommentSection, InnerWrapper, FeedbackHeaderWrapper, FeedbackInfoBar, FeedbackInfoText, FeedbackInfoName, } from "../hiring-feedback-v2/style";
import { MANAGER_ENDPOINTS } from "../../utils/endpoints";
import FeedbackFormHeader from "../feedback-v2-header";
import QuestionsAskedList from "../hiring-feedback-v2/QuestionsAskedList";
import NeedHelpSupport from "../need-help-support";
import { hydrateManagerUserFromStorage } from "../../utils/manager-login-profile";
const getLoggedInSubmitterName = (user) => [user === null || user === void 0 ? void 0 : user.firstName, user === null || user === void 0 ? void 0 : user.lastName].filter(Boolean).join(" ").trim();
/**
 * Additional HM remark form for in-meeting panel.
 * Same flow as Admin FE: GET existing remark → template → submit only Remark
 * section → read-only Questions + Feedback.
 */
const HiringFeedbackAdditional = (props) => {
    var _a, _b, _c, _d, _e;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userId = props.userId || searchParams.get("id") || undefined;
    const courseId = props.courseId || searchParams.get("courseId") || undefined;
    const primaryHmId = (_c = (_b = (_a = props.primaryHmId) !== null && _a !== void 0 ? _a : searchParams.get("primaryHmId")) !== null && _b !== void 0 ? _b : sessionStorage.getItem("additional_hm_primary_hm_id")) !== null && _c !== void 0 ? _c : undefined;
    const panelInterviewId = (_e = (_d = props.panelInterviewId) !== null && _d !== void 0 ? _d : searchParams.get("panelInterviewId")) !== null && _e !== void 0 ? _e : undefined;
    const { user, setUser } = useApplicationContext();
    useEffect(() => {
        hydrateManagerUserFromStorage(setUser);
    }, [setUser]);
    const [template, setTemplate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [sectionResponses, setSectionResponses] = useState({});
    const [candidateName, setCandidateName] = useState("");
    const [candidateProfileImage, setCandidateProfileImage] = useState("");
    const [resumeLink, setResumeLink] = useState("");
    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
    const [existingFeedback, setExistingFeedback] = useState(null);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [feedbackMetadata, setFeedbackMetadata] = useState(null);
    const panelMemberId = (user === null || user === void 0 ? void 0 : user.id) || sessionStorage.getItem("userId");
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        const month = months[date.getMonth()];
        const year = date
            .getFullYear()
            .toString()
            .slice(-2);
        return `${day} ${month} '${year}`;
    };
    const applyExistingFeedbackResult = (result) => {
        if ((result === null || result === void 0 ? void 0 : result.isSubmitted) && (result === null || result === void 0 ? void 0 : result.feedback)) {
            setExistingFeedback(result);
            setIsReadOnly(true);
            setFeedbackMetadata({
                feedbackSubmittedByName: result.feedback.feedbackSubmittedByName || "",
                submittedAt: result.feedback.submittedAt || result.remarkSubmittedAt || "",
            });
            return true;
        }
        setExistingFeedback(null);
        setIsReadOnly(false);
        setFeedbackMetadata(null);
        return false;
    };
    useEffect(() => {
        const initFeedbackPage = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!courseId) {
                setError("Invalid URL. Please try again.");
                return;
            }
            setLoading(true);
            setError(null);
            let alreadySubmitted = false;
            if (userId && panelMemberId) {
                try {
                    const response = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_ADDITIONAL_HM_FEEDBACK_V2, {
                        params: Object.assign(Object.assign({ courseId,
                            userId,
                            panelMemberId }, (primaryHmId != null ? { primaryHmId } : {})), (panelInterviewId != null ? { panelInterviewId } : {})),
                    });
                    alreadySubmitted = applyExistingFeedbackResult((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result);
                }
                catch (_d) {
                    alreadySubmitted = applyExistingFeedbackResult(null);
                }
            }
            // Template only needed when remark is not yet submitted.
            if (!alreadySubmitted) {
                try {
                    const response = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_FEEDBACK_TEMPLATE_V2, { params: { courseId, isPrimaryHMTemplate: false } });
                    const result = (_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.template;
                    if (result) {
                        setTemplate(result);
                    }
                    else {
                        throw new Error("Template not found in response");
                    }
                }
                catch (err) {
                    setError((err === null || err === void 0 ? void 0 : err.message) ||
                        "Failed to load feedback template. Please try again later.");
                }
            }
            setLoading(false);
        });
        void initFeedbackPage();
    }, [courseId, userId, panelMemberId, primaryHmId, panelInterviewId]);
    useEffect(() => {
        const fetchUserDetailsAndProfilePhoto = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!userId) {
                return;
            }
            setCandidateProfileImage("");
            try {
                const response = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_USER_DETAILS, { params: { userId } });
                const result = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.result;
                if (result) {
                    setCandidateName(result.name || "");
                    setResumeLink(result.resumeLink || "");
                }
            }
            catch (_d) {
                message.error("Failed to load user resume.");
            }
            if (!courseId) {
                return;
            }
            try {
                const photoResponse = yield apiClientServices.get(MANAGER_ENDPOINTS.GET_PROFILE_PHOTO_URL, { params: { userId, courseId } });
                const profilePhoto = (_c = (_b = photoResponse === null || photoResponse === void 0 ? void 0 : photoResponse.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.profilePhoto;
                const trimmedPhoto = typeof profilePhoto === "string" ? profilePhoto.trim() : "";
                setCandidateProfileImage(trimmedPhoto);
            }
            catch (_e) {
                setCandidateProfileImage("");
            }
        });
        fetchUserDetailsAndProfilePhoto();
    }, [userId, courseId]);
    useEffect(() => {
        if (!template || isReadOnly)
            return;
        setSectionResponses(template.sections.reduce((acc, _, index) => {
            acc[index] = { comment: "" };
            return acc;
        }, {}));
    }, [template, isReadOnly]);
    const remarkSectionIndex = useMemo(() => {
        if (!template)
            return -1;
        return template.sections.findIndex((section) => section.isCommentsEnabled);
    }, [template]);
    const storedRemarkSections = useMemo(() => {
        var _a;
        const responses = (_a = existingFeedback === null || existingFeedback === void 0 ? void 0 : existingFeedback.feedback) === null || _a === void 0 ? void 0 : _a.sectionResponses;
        if (!Array.isArray(responses) || responses.length === 0) {
            return [];
        }
        return responses;
    }, [existingFeedback]);
    const remarkFilled = useMemo(() => {
        var _a, _b, _c;
        if (remarkSectionIndex < 0)
            return false;
        return Boolean((_c = (_b = (_a = sectionResponses[remarkSectionIndex]) === null || _a === void 0 ? void 0 : _a.comment) === null || _b === void 0 ? void 0 : _b.trim()) === null || _c === void 0 ? void 0 : _c.length);
    }, [remarkSectionIndex, sectionResponses]);
    const feedbackByDisplayName = useMemo(() => {
        var _a;
        if (!isReadOnly || !feedbackMetadata)
            return "";
        return ((_a = feedbackMetadata.feedbackSubmittedByName) === null || _a === void 0 ? void 0 : _a.trim()) || "";
    }, [feedbackMetadata, isReadOnly]);
    const handleCommentChange = (sectionIndex, value) => {
        setSectionResponses((prev) => (Object.assign(Object.assign({}, prev), { [sectionIndex]: Object.assign(Object.assign({}, prev[sectionIndex]), { comment: value }) })));
    };
    const submitRemark = () => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g, _h, _j, _k;
        if (!template || remarkSectionIndex < 0)
            return;
        const feedbackActorEmail = (user === null || user === void 0 ? void 0 : user.email) || sessionStorage.getItem("email") || "";
        const feedbackSubmittedByName = getLoggedInSubmitterName(user);
        const remarkSection = template.sections[remarkSectionIndex];
        const remarkComment = ((_g = (_f = sectionResponses[remarkSectionIndex]) === null || _f === void 0 ? void 0 : _f.comment) === null || _g === void 0 ? void 0 : _g.trim()) || "";
        const payload = Object.assign(Object.assign(Object.assign({ userId: Number(userId), courseId: Number(courseId) }, (primaryHmId != null ? { primaryHmId: Number(primaryHmId) } : {})), (panelInterviewId != null
            ? { panelInterviewId: Number(panelInterviewId) }
            : {})), { candidateName, sectionResponses: [
                {
                    sectionTitle: remarkSection.title,
                    competency: remarkSection.competency,
                    questionsAsked: remarkSection.questionsAsked || [],
                    feedback: [],
                    comments: remarkComment,
                },
            ], feedbackDoneBy: feedbackActorEmail, feedbackSignedBy: feedbackActorEmail, feedbackSubmittedByName, submittedAt: new Date().toISOString() });
        if (!panelMemberId) {
            message.error("Unable to identify the logged-in panel member.");
            return;
        }
        setIsSubmitting(true);
        try {
            const response = yield apiClientServices.post(MANAGER_ENDPOINTS.SUBMIT_ADDITIONAL_HM_FEEDBACK_V2, payload);
            if (((_h = response === null || response === void 0 ? void 0 : response.data) === null || _h === void 0 ? void 0 : _h.status) === 201) {
                message.success("Feedback is submitted");
                setIsReadOnly(true);
                setExistingFeedback((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.result);
                setFeedbackMetadata({
                    feedbackSubmittedByName,
                    submittedAt: payload.submittedAt,
                });
                return;
            }
            message.error(((_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.message) || "Failed to submit remark. Please try again.");
        }
        catch (_l) {
            message.error("Failed to submit remark. Please try again.");
        }
        finally {
            setIsSubmitting(false);
        }
    });
    const handleSubmit = () => {
        if (isReadOnly || isSubmitting) {
            return;
        }
        if (!template)
            return;
        if (!courseId || !userId) {
            message.error("Missing courseId or userId.");
            return;
        }
        if (!remarkFilled) {
            message.warning("Please enter your remark before submitting.");
            return;
        }
        setIsConfirmModalVisible(true);
    };
    const handleConfirmSubmit = () => {
        setIsConfirmModalVisible(false);
        void submitRemark();
    };
    const handleCancelSubmit = () => {
        setIsConfirmModalVisible(false);
    };
    if (loading) {
        return (_jsx(Wrapper, { children: _jsx(Spin, {}) }));
    }
    if (error) {
        return (_jsx(Wrapper, { children: _jsx(Alert, { type: "error", message: error }) }));
    }
    if (!template && !isReadOnly) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Wrapper, { children: [_jsx(FeedbackHeaderWrapper, { children: _jsx(FeedbackFormHeader, { candidateName: candidateName, resumeLink: resumeLink, profileImage: candidateProfileImage, isReadOnly: isReadOnly, showScore: false, onResumeView: () => {
                                if (resumeLink) {
                                    window.open(resumeLink, "_blank", "noopener,noreferrer");
                                }
                            } }) }), _jsxs(InnerWrapper, { children: [isReadOnly && storedRemarkSections.length > 0
                                ? storedRemarkSections.map((section, sectionIndex) => {
                                    var _a;
                                    return (_jsxs(SectionCard, { children: [_jsx(SectionHeader, { children: section.sectionTitle || "Remark" }), _jsx(SectionDivider, {}), _jsxs(SectionBody, { children: [(((_a = section.questionsAsked) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0 && (_jsxs(Block, { children: [_jsx(BlockTitle, { children: "Questions" }), _jsx(BlockCard, { children: _jsx(QuestionsAskedList, { questionsAsked: section.questionsAsked || [], sectionTitle: section.sectionTitle || "remark", showOrBetweenQuestions: sectionIndex === 0 }) })] })), _jsxs(Block, { children: [_jsx(BlockTitle, { children: "Feedback" }), _jsx(BlockCardCommentSection, { children: _jsx(CommentsTextArea, { autoSize: { minRows: 3 }, value: section.comments || "", readOnly: true }) })] })] })] }, `${section.sectionTitle || "remark"}-${sectionIndex}`));
                                })
                                : template === null || template === void 0 ? void 0 : template.sections.map((section, sectionIndex) => {
                                    var _a, _b;
                                    return (_jsxs(SectionCard, { children: [_jsx(SectionHeader, { children: section.title }), _jsx(SectionDivider, {}), _jsxs(SectionBody, { children: [(((_a = section.questionsAsked) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0 && (_jsxs(Block, { children: [_jsx(BlockTitle, { children: "Questions" }), _jsx(BlockCard, { children: _jsx(QuestionsAskedList, { questionsAsked: section.questionsAsked, sectionTitle: section.title, showOrBetweenQuestions: sectionIndex === 0 }) })] })), section.isCommentsEnabled && (_jsxs(Block, { children: [_jsx(BlockTitle, { children: "Remark" }), _jsx(BlockCardCommentSection, { children: _jsx(CommentsTextArea, { autoSize: { minRows: 3 }, placeholder: "Give your Feedback/ Remark for this candidate", value: (_b = sectionResponses[sectionIndex]) === null || _b === void 0 ? void 0 : _b.comment, onChange: (event) => handleCommentChange(sectionIndex, event.target.value), readOnly: isSubmitting }) })] }))] })] }, `${section.title}-${sectionIndex}`));
                                }), isReadOnly && feedbackMetadata ? (_jsxs(FeedbackInfoBar, { children: [feedbackByDisplayName ? (_jsxs(FeedbackInfoText, { children: ["Feedback by:", " ", _jsx(FeedbackInfoName, { children: feedbackByDisplayName })] })) : null, feedbackMetadata.submittedAt ? (_jsxs(FeedbackInfoText, { children: ["Submitted on: ", formatDate(feedbackMetadata.submittedAt)] })) : (_jsx(FeedbackInfoText, { children: "Feedback already submitted" }))] })) : (_jsx(SubmitButtonWrapper, { children: _jsx(SubmitButton, Object.assign({ type: "primary", onClick: handleSubmit, disabled: isSubmitting }, { children: "Submit Remark" })) }))] }), _jsx(NeedHelpSupport, {})] }), _jsx(Modal, Object.assign({ open: isConfirmModalVisible, onCancel: handleCancelSubmit, footer: null, centered: true, destroyOnClose: true }, { children: _jsxs("div", Object.assign({ style: { textAlign: "center", paddingTop: 8, paddingBottom: 8 } }, { children: [_jsx(ExclamationCircleOutlined, { style: { fontSize: 32, color: "#F7B500" } }), _jsx("h3", Object.assign({ style: { marginTop: 16, marginBottom: 8 } }, { children: "Confirm Submission" })), _jsxs("p", Object.assign({ style: { margin: 0, color: "#6B7280" } }, { children: ["You\u2019re about to submit your remark.", _jsx("br", {}), "Once saved, it can\u2019t be edited or changed later."] })), _jsxs("div", Object.assign({ style: {
                                marginTop: 24,
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 12,
                            } }, { children: [_jsx(Button, Object.assign({ onClick: handleCancelSubmit, style: { flex: 1, borderRadius: 6 } }, { children: "Cancel" })), _jsx(Button, Object.assign({ type: "primary", danger: true, onClick: handleConfirmSubmit, style: { flex: 1, borderRadius: 6 } }, { children: "Confirm" }))] }))] })) }))] }));
};
export default HiringFeedbackAdditional;
